import { RestClient } from "./restClient";

export class EcoSettingsService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	create(setting, callback) {
		const url = "/ecosystem/api/ecoSettings";
		const body = JSON.stringify(setting);
		this._restClient.exec_post(url, body, callback);
	}

	update(setting, callback) {
		const url = `/ecosystem/api/ecoSettings/${setting.id}`;
		const body = JSON.stringify(setting);
		this._restClient.exec_put(url, body, callback);
	}

	delete(settingId, callback) {
		const url = `/ecosystem/api/ecoSettings/${settingId}`;
		this._restClient.exec_delete(url, callback);
	}

	getByKey(key, callback) {
		const url = `/ecosystem/api/ecoSettings/${key}`;
		this._restClient.exec_get(url, callback);
	}

	getAll(callback) {
		const url = "/ecosystem/api/ecoSettings";
		this._restClient.exec_get(url, callback);
	}
}
